// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__24qes","footer":"ModalUpdate_footer__2Pro8"};